module.exports = __webpack_public_path__ + "img/pr-7.b7e9ffa9.png";